import React from "react";
import { Link } from "gatsby";

import Layout from "components/Layout";
import Seo from "components/Seo";
import useTranslation from "locales";

import SubpageHeader from "components/SubpageHeader";
import RealizationsSlider from "components/RealizationsSlider";

import "styles/pages/single-news.scss";

const SinglePost = ({ pageContext }) => {
	const post = pageContext.data;
	const seo = pageContext.seo;
	const lang = pageContext.language?.slug;
	const { t } = useTranslation(lang);

	const slider_images = post?.postAcf?.slider
		? [post?.featuredImage.node, ...post?.postAcf?.slider]
		: [post?.featuredImage.node];

	return (
		<Layout lang={lang}>
			<Seo
				title={seo.title ? seo.title : pageContext.title}
				description={seo.metaDesc}
			/>
			<SubpageHeader
				lang={lang}
				title="Aktualności"
				back={t("/aktualnosci/")}
			/>
			<section className="section-single-news">
				<div className="container">
					<div className="row">
						<div className="col-xl-5 section-single-news__col">
							<RealizationsSlider images={slider_images} />
						</div>
						<div className="col-xl-6 offset-xl-1 section-single-news__col">
							<div className="section-single-news__date">
								{post.date}
							</div>
							<h4 className="section-single-news__title">
								{post.title}
							</h4>
							<div
								className="section-single-news__text"
								dangerouslySetInnerHTML={{
									__html: post.content,
								}}
							/>
							<div className="section-single-news__btn-group">
								{pageContext.previous !== null && (
									<Link
										to={pageContext.previous}
										className="link-line link-line--hide-mobile"
									>
										{t("Poprzedni")}
									</Link>
								)}
								{pageContext.next !== null && (
									<Link
										to={pageContext.next}
										className="link-line link-line--reversed link-line--hide-mobile"
									>
										{t("Następny")}
									</Link>
								)}
							</div>
						</div>
					</div>
				</div>
			</section>
		</Layout>
	);
};

export default SinglePost;
